"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const merlin_spacer_1 = require("@travelnest/merlin.spacer");
const merlin_theme_1 = __importDefault(require("@travelnest/merlin.theme"));
const merlin_typography_1 = require("@travelnest/merlin.typography");
const React = __importStar(require("react"));
const SelectWrapper = styled_1.default.div `
	width: 100%;
	position: relative;
	:before {
        content: "\\e901"; /* Arrow down */
        font-family: ${merlin_theme_1.default.typography.fonts.icons};
        text-align: center;
        position: absolute;
        top: 0.5rem;
        right: 2px;
		pointer-events: none;
		z-index: 1;
		font-size: 2rem;
		color: ${merlin_theme_1.default.colours.neutral.darkest};
    }

	:after {
		content: '';
		display: block;
		position: absolute;
		top: -2px;
		bottom: -2px;
		right: -2px;
		left: -2px;
		opacity: 0;
		border: 1px solid ${merlin_theme_1.default.colours.highlight.default};
		transition: opacity ${merlin_theme_1.default.motion.transition.default};
		-webkit-transition: opacity ${merlin_theme_1.default.motion.transition.default};
		pointer-events: none;
		border-radius: calc(${merlin_theme_1.default.layout.radius.squared} + 1px);
	}

	/* transition on opacity - fades in when focused */
	:focus-within:after {
		opacity: 1;
	}
`;
const StyledSelect = styled_1.default.select `
    -webkit-appearance: none;
    -moz-appearance: none;
	&::-ms-expand { display: none; }
	${merlin_theme_1.default.typography.c3};
	outline: none;
	border: 1px solid ${merlin_theme_1.default.colours.neutral.light};
	border-radius: ${merlin_theme_1.default.layout.radius.squared};
	height: 2.8125rem;
	background: #ffffff;
	width: 100%;
	padding: 0 ${merlin_theme_1.default.layout.spacing.large} 0 ${merlin_theme_1.default.layout.spacing.small};
	transition: border 0.2s;
	cursor: pointer;
	text-overflow: ellipsis;
	// chrome user agent style sheet has select:not(:-internal-list-box) { overflow: visible !important; }
	overflow: hidden !important;
	white-space: nowrap;


	${({ valid }) => !valid && `
		border-color: ${merlin_theme_1.default.colours.error.default};
		color: ${merlin_theme_1.default.colours.error.default};
		background-color: ${merlin_theme_1.default.colours.error.tint};
	`};

	&:focus, &:hover, &:active {
		border: 1px solid ${merlin_theme_1.default.colours.neutral.dark};
		${({ valid }) => !valid && `
			border-color: ${merlin_theme_1.default.colours.error.default};
			color: ${merlin_theme_1.default.colours.error.default};
			background-color: ${merlin_theme_1.default.colours.error.tint};
		`};
	}
	&:disabled {
		background: ${merlin_theme_1.default.colours.neutral.lighter};
		color: ${merlin_theme_1.default.colours.neutral.darker};
		cursor: not-allowed;
		opacity: 1;
	}
	&:disabled:hover {
		border: 1px solid ${merlin_theme_1.default.colours.neutral.light};
	}
`;
const Select = (props) => {
    const { label, hintText, id, valid } = props, rest = __rest(props, ["label", "hintText", "id", "valid"]);
    const showLabel = label && (React.createElement(React.Fragment, null,
        React.createElement(merlin_typography_1.Label, { htmlFor: id }, label),
        React.createElement(merlin_spacer_1.Spacer, { spacing: "smaller" })));
    const showHintText = hintText && (React.createElement(React.Fragment, null,
        React.createElement(merlin_typography_1.HintText, { id: `${id}-hint` }, hintText),
        React.createElement(merlin_spacer_1.Spacer, { spacing: "smaller" })));
    return (React.createElement(React.Fragment, null,
        showLabel,
        showHintText,
        React.createElement(SelectWrapper, null,
            React.createElement(StyledSelect, Object.assign({ id: id, valid: valid === undefined ? true : valid, "data-testid": id }, rest), props.children))));
};
exports.Select = Select;
//# sourceMappingURL=Select.js.map